import React from 'react'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { DateTime } from 'luxon';

function YearFilter({goBack, year, lastYear, goForward, data, yearPrevious}) {
    let dataLength = data && data.filter((r) => r.data_competenza.includes(yearPrevious)).length
    
    return (
        <div className="year_filter">
            <div className="year_filter-dateChanger">
                <ArrowBackIosIcon style={ dataLength === 0 ? { fill: '#EBEBEB' } : { fill: '#697386' }} onClick={() => dataLength === 0 ? null : goBack()} />
                <p className='main'>{year}</p>
                <ArrowForwardIosIcon style={year === lastYear ? { fill: '#EBEBEB' } : { fill: '#697386' }} onClick={() => year === lastYear ? null : goForward()} />
            </div>
            <div className="year_filter-switch">
            </div>
        </div>
    )
}

export default YearFilter